export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/power_bi.c464927.svg";